module.exports = __webpack_public_path__ + "img/fh.50d01388.png";